import {Component, EventEmitter, HostListener, Input, OnInit, Output} from '@angular/core'
import {UtilsService} from 'src/app/services/utils/utils.service'
import {Router} from "@angular/router";
import {UserService} from "../../services/user/user.service";
import {IonicModule, ToastController} from '@ionic/angular';
import {TranslateModule, TranslateService} from '@ngx-translate/core';
import {CommonModule} from '@angular/common';
import {DetailsHeaderComponent} from '../details-header/details-header.component';
import {PhotoGalleryComponent} from '../photo-gallery/photo-gallery.component';
import {DialogComponent} from '../dialog/dialog.component';

@Component({
  selector: 'app-details-web',
  templateUrl: './details-web.component.html',
  styleUrls: ['./details-web.component.scss'],
  standalone: true,
  imports: [CommonModule, IonicModule, TranslateModule, DetailsHeaderComponent, PhotoGalleryComponent, DialogComponent]
})
export class DetailsWebComponent implements OnInit {
  @Input() post: any
  @Input() mode: any
  @Input() guest: any
  @Output() toggleGuestModal = new EventEmitter()
  @Output() toggleModal = new EventEmitter()
  isWeb: boolean = false
  showContactRequestDialog = false

  constructor(
    private utilsService: UtilsService,
    private userService: UserService,
    private router: Router,
    private toastController: ToastController,
    private translate: TranslateService
  ) {}

  isMobile = false

  @HostListener('window:resize')
  onResize() {
    this.checkScreenSize()
  }

  checkScreenSize() {
    this.isMobile = window.innerWidth < 768
  }

  userModal() {
    this.toggleGuestModal.emit()
  }

  toggleShow() {
    this.toggleModal.emit()
  }

  async openContactRequestDialog(): Promise<void> {
    // Gate: prevent contacting own listing
    if (this.isOwner()) {
      const msg = this.translate.instant('DETAILS_WEB.CANNOT_CONTACT_OWN');
      const toast = await this.toastController.create({
        message: msg || 'No puedes contactar a tu propia publicación',
        duration: 3000,
        color: 'warning',
        position: 'bottom'
      });
      toast.present();
      return;
    }
    // Found objects skip the intention explanation dialog
    if (this.post?.type === 'found') {
      this.confirmContactRequest();
      return;
    }
    this.showContactRequestDialog = true
  }

  cancelContactRequestDialog() {
    this.showContactRequestDialog = false
  }

  confirmContactRequest() {
    this.showContactRequestDialog = false
    this.toggleShow()
  }

  navigate(path: string) {
    this.router.navigate([path])
  }

  async ngOnInit() {
    this.checkScreenSize()
    this.isWeb = await this.utilsService.detectIsWeb()
  }

  isOwner() {
    const current = this.userService.getUser();
    return !!this.post?.user?.id && !!current?.id && this.post.user.id === current.id;
  }

  /** Returns the i18n key for the contact button based on the post type. */
  getContactButtonKey(): string {
    return this.post?.type === 'found'
      ? 'DETAILS_WEB.CONTACT_FOUND_BUTTON'
      : 'DETAILS_WEB.CONTACT_LOST_BUTTON';
  }

  /** Returns the i18n key for the informational text based on the post type. */
  getInfoTextKey(): string {
    return this.post?.type === 'found'
      ? 'DETAILS_WEB.FOUND_INFO_TEXT'
      : 'DETAILS_WEB.LOST_INFO_TEXT';
  }

  /** Returns the i18n key for the contact dialog body based on the post type. */
  getContactDialogBodyKey(): string {
    return this.post?.type === 'found'
      ? 'DETAILS_WEB.FOUND_INFO_TEXT'
      : 'DIALOG.NOTIFY_OWNER_BODY';
  }
}
